import type { TimesheetEntry } from "../types.ts";

/**
 * Entry may be corrected in UI when the API marks it editable and rejected.
 * Backend may send `approvalStatus` and/or `approverStatus`.
 */
export function isRejectedEditableEntry(entry: TimesheetEntry): boolean {
  if (entry.editable !== true) return false;
  const status = (
    entry.approvalStatus ??
    entry.approverStatus ??
    ""
  )
    .toString()
    .toUpperCase();
  return status === "REJECTED";
}
